import type { MetricDefinition } from '@citilight-monitor/contracts';

/** A server is monitored via node_exporter (it has a cpu_percent metric); everything else is an application. */
export function isServer(metrics: MetricDefinition[]): boolean {
  return metrics.some((m) => m.key === 'cpu_percent');
}
